import Banner from './components/banner'
import Tabs from '@commons/tabs'
import PersonalDetails from './components/personalDetails'
import Availabilities from './components/availabilities'
import Staffs from './components/staffs'
import Column from '@components/column'
import { useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { User } from '@apis'
const AdminInstitutionDetailsPage = () => {
  const { data } = useSelector((state: any) => state.institution)
  const { state } = useLocation()
  const { id } = useParams()
  const institution = state?.id ? state : data
  const items = [
    {
      title: 'Profile Details',
      key: 'profile-details',
      Component: PersonalDetails,
      props: {
        institution,
        disabled: true,
      },
    },
    {
      title: 'Availability',
      key: 'availability',
      Component: Availabilities,
      props: {
        institution,
      },
    },
    {
      title: 'Medical Staff',
      key: 'staffs',
      Component: Staffs,
    },
  ]
  const fetchInstitution = async () => {
    await User.get({
      state: 'institution',
      id: id,
    }).catch(() => {})
  }

  useEffect(() => {
    if (!state?.id) {
      fetchInstitution()
    }
  }, [])
  return (
    <>
      <Banner institution={institution} />
      <Column styleColumn="margin-top:30px;">
        <Tabs items={items} />
      </Column>
    </>
  )
}

export default AdminInstitutionDetailsPage
